module.exports = __webpack_public_path__ + "static/05-45ab644636241a70ae6224f1b2b2dbf2.jpg";